import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">OBX Gallery · Celebrating Local Art</p>
        <h1>Discover the Heart of Outer Banks Art</h1>
        <p className="lede">
          Explore a vibrant collection of artwork from talented local artists, showcasing the beauty and spirit of the Outer Banks. Join us in celebrating creativity and community.
        </p>
        <div className="cta-row">
          <a href="/gallery" target="_self">
            View Our Collection
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Support Local Artists</h2>
          <p>
            Every piece tells a story. By purchasing artwork, you are directly supporting the talented individuals who bring the Outer Banks to life through their creativity.
          </p>
        </article>
        <article>
          <h2>Unique Artwork</h2>
          <p>
            Our gallery features a diverse range of styles and mediums, ensuring that there is something for every art lover. Discover unique pieces that resonate with you.
          </p>
        </article>
        <article>
          <h2>Join Our Community</h2>
          <p>
            Connect with fellow art enthusiasts and participate in local events. Become a part of the vibrant Outer Banks art scene and share your passion for creativity.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;